import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Clients from "@/components/site/Clients";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import Portfolio from "@/components/site/Portfolio";
import Pricing from "@/components/site/Pricing";
import CarePlans from "@/components/site/CarePlans";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import StickyCTA from "@/components/site/StickyCTA";

const Home = () => {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    // Handle deep-link hash (e.g. /#contact, /#work) after mount
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) lenis.scrollTo(el, { offset: -80 });
      }, 300);
    }

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.lenis;
    };
  }, []);

  const scrollToContact = () => {
    const el = document.querySelector("#contact");
    if (!el) return;
    if (window.lenis) window.lenis.scrollTo(el.getBoundingClientRect().top + window.scrollY - 80);
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="relative bg-[#0A1428] min-h-screen">
      <Navbar onContact={scrollToContact} />
      <main>
        <Hero onContact={scrollToContact} />
        <Clients />
        <Marquee />
        <Services onContact={scrollToContact} />
        <Process />
        <Portfolio />
        <About />
        <Pricing onContact={scrollToContact} />
        <CarePlans />
        <Contact />
      </main>
      <Footer onContact={scrollToContact} />
      <StickyCTA onContact={scrollToContact} />
    </div>
  );
};

export default Home;
